var map = {
	"./ic-arrow-right-pink.svg": "b01b",
	"./ic-arrow-right-solid-black.svg": "a479",
	"./ic-arrow-right-white.svg": "650a",
	"./ic-bag-in-the-box.svg": "f2c9",
	"./ic-facebook.svg": "6e6f",
	"./ic-heart-blue.svg": "d239",
	"./ic-heart-bold-pink.svg": "5b3a",
	"./ic-heart-pink.svg": "56d9",
	"./ic-instagram.svg": "fd35",
	"./ic-install-app-header-underline.svg": "0dcd",
	"./ic-money-bag.svg": "df4f",
	"./ic-neck-pink.svg": "9c62",
	"./ic-new-window-pink.svg": "329a",
	"./ic-ring-pink.svg": "9b5f",
	"./ic-ring-solid-pink.svg": "73ca",
	"./ic-ring-white.svg": "251e",
	"./ic-twitter.svg": "a0fb",
	"./ic-youtube.svg": "e886"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "909e";